// module_configs/pvc.js
import React from 'react';
import { 
  faGaugeHigh, faUsers, faUserPlus, faUsersLine, faBuilding, faUserTie,
  faBuildingUser, faUserGroup, faIdCard, faCubes, faCube, faListAlt,
  faTruckFast, faCartPlus, faFileInvoice, faReceipt, faArrowRotateLeft,
  faRotateLeft, faListCheck, faQrcode, faPrint, faCartShopping, faClipboardList,
  faArrowRightArrowLeft, faMoneyBillWave, faPlus, faGear, faBullhorn,
  faLayerGroup, faBoxes, faCog, faIndustry, faUsersCog, faClock
} from '@fortawesome/free-solid-svg-icons';

// Import PVC components (adjust imports as needed)
import DashboardHome from '.././module_cosmetics/cosmetics_homedash';
import RootUsers from '.././module_roots/RootUsers';
import MessageSystem from '.././module_roots/MessageSystem';

export const pvcConfig = {
  moduleId: 'pvc',
  moduleName: 'PVC',
  icon: faIndustry,
  description: 'PVC & Pipes Management System',
  
  dashboardComponent: DashboardHome,
  
  roles: {
    'admin_pvc': { level: 1, label: 'Admin', color: '#06b6d4' },
    'manager_pvc': { level: 2, label: 'Manager', color: '#0891b2' },
    'user_pvc': { level: 3, label: 'User', color: '#0e7490' },
    'viewer_pvc': { level: 4, label: 'Viewer', color: '#155e75' }
  },
  
  menuGroups: [
    { id: 'management', name: 'Management', icon: faUsersCog, order: 1 },
    { id: 'inventory', name: 'Inventory & Stock', icon: faBoxes, order: 2 },
    { id: 'sales', name: 'Sales & Transactions', icon: faMoneyBillWave, order: 3 },
    { id: 'system', name: 'System Settings', icon: faCog, order: 4 }
  ],
  
  menus: [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: faGaugeHigh,
      component: DashboardHome,
      roles: ['all'],
      groupId: 'management',
      position: 0
    },
    // Add PVC-specific menus here
    {
      id: 'settings',
      label: 'Settings',
      icon: faGear,
      component: RootUsers,
      roles: ['admin_pvc'],
      groupId: 'system',
      position: 10,
      submenus: []
    },
    {
      id: 'systemupdates',
      label: 'Notifications Center',
      icon: faBullhorn,
      component: MessageSystem,
      roles: ['admin_pvc', 'manager_pvc', 'user_pvc'],
      groupId: 'system',
      position: 11,
      submenus: []
    }
  ],
  
  quickStats: [
    { id: 'todaySales', label: "Today's Sales", icon: 'faChartLine', value: '$2,800' },
    { id: 'products', label: 'Products', icon: 'faBoxes', value: 198 },
    { id: 'customers', label: 'Customers', icon: 'faUsers', value: 56 },
    { id: 'pending', label: 'Pending Orders', icon: 'faClock', value: 6 }
  ],
  
  shortcuts: [
    { key: 'Alt + D', description: 'Dashboard' },
    { key: 'Alt + H', description: 'Toggle Shortcuts Panel' }
  ]
};